import Vue from 'vue';
import Vuex from 'vuex';
import Profile from '@/store/profile/state';
import Settings from '@/store/settings/state';
import Auth from '@/store/auth/auth';
import Content from '@/store/content/content';
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        Auth,
        Content,
        Profile,
        Settings
    }
});
